import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import FundsTable from '../../organisms/FundsTable'
import FundsFilter from '../../organisms/FundsFilter'
import Loader from '../../atoms/Loader'
import Footer from '../../atoms/Footer'

import './style.scss'

const FundList = ({
  id,
  fundTableHeader,
  tableData,
  isSelectable,
  caption,
  tableProps,
  filterData,
  updateFilterData,
  totalResultConfig,
  groupFilterConfig,
  footerInfo,
  downloadOptions,
  selectedGroupOption,
  tableCallback,
  expandAllCallback
}) => {
  return (
    <div id={id}>
      <GridContainer>
        <Grid direction="grid-x">
          <Cell className="small-12">
            {!isEmpty(filterData) && <FundsFilter {...{ filterData, updateFilterData, downloadOptions }} />}
            {tableData ? (
              <FundsTable
                {...{
                  id,
                  fundTableHeader,
                  isSelectable,
                  caption,
                  tableProps,
                  tableData,
                  totalResultConfig,
                  selectedGroupOption,
                  groupFilterConfig,
                  downloadOptions,
                  tableCallback,
                  expandAllCallback
                }}
              />
            ) : (
              <Loader />
            )}
            <div className="fil-fund-list-footer">
              <Footer {...footerInfo} />
            </div>
          </Cell>
        </Grid>
      </GridContainer>
    </div>
  )
}

FundList.propTypes = {
  id: PropTypes.string.isRequired,
  tableData: PropTypes.object,
  caption: PropTypes.string,
  isSelectable: PropTypes.bool,
  fundTableHeader: PropTypes.element,
  tableProps: PropTypes.object,
  filterData: PropTypes.object,
  updateFilterData: PropTypes.func,
  totalResultConfig: PropTypes.object,
  groupFilterConfig: PropTypes.object,
  footerInfo: PropTypes.object,
  downloadOptions: PropTypes.object,
  selectedGroupOption: PropTypes.object,
  tableCallback: PropTypes.func,
  expandAllCallback: PropTypes.func
}

FundList.defaultProps = {
  tableData: null,
  caption: '',
  isSelectable: false,
  fundTableHeader: null,
  tableProps: {},
  filterData: {},
  updateFilterData: () => {},
  totalResultConfig: {},
  groupFilterConfig: null,
  footerInfo: {},
  downloadOptions: {},
  selectedGroupOption: {},
  tableCallback: () => {},
  expandAllCallback: () => {},
}

export default FundList
